import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ICardlinkDigestCalculationResult } from './digest-result.model';
import { CardlinkRequestMessage } from './cardlink-request-message.model';

@Injectable({
    providedIn: 'root'
})
export class CardlinkService {
    private baseUrl = 'https://garage.zilioo.gr/CardlinkEcommerce';

    constructor(private http: HttpClient) {}

    // calculateDigest(cardlinkRequestMessage: CardlinkRequestMessage) {
    //     return this.http.post<ICardlinkDigestCalculationResult>(
    //         `${this.baseUrl}/calculate-digest`,
    //         cardlinkRequestMessage
    //     );
    // }
    postScheduledRecurring(data: any): Observable<any> {
        return this.http.post(
            `${this.baseUrl}/cardlink-scheduled-recurring`,
            data
        );
    }

    postPaymentAdvice(data: any): Observable<any> {
        return this.http.post(`${this.baseUrl}/cardlink-payment-advice`, data);
    }

    postCaptureAdvice(data: any): Observable<any> {
        return this.http.post(`${this.baseUrl}/cardlink-capture-advice`, data);
    }

    postCancelAdvice(data: any): Observable<any> {
        return this.http.post(`${this.baseUrl}/cardlink-cancel-advice`, data);
    }

    postRefundAdvice(data: any): Observable<any> {
        return this.http.post(`${this.baseUrl}/cardlink-refund-advice`, data);
    }

    postRecurringAdvice(data: any): Observable<any> {
        return this.http.post(
            `${this.baseUrl}/cardlink-recurring-advice`,
            data
        );
    }
}

export const CardlinkDigestFieldOrder = {
    scheduledRecurring: [
        'version',
        'mid',
        'lang',
        'deviceCategory',
        'orderid',
        'orderDesc',
        'orderAmount',
        'currency',
        'payerEmail',
        'payerPhone',
        'billCountry',
        'billState',
        'billZip',
        'billCity',
        'billAddress',
        'weight',
        'dimensions',
        'shipCountry',
        'shipState',
        'shipZip',
        'shipCity',
        'shipAddress',
        'addFraudScore',
        'maxPayRetries',
        'reject3dsU',
        'payMethod',
        'trType',
        'extInstallmentoffset',
        'extInstallmentperiod',
        'extRecurringfrequency',
        'extRecurringenddate',
        'blockScore',
        'cssUrl',
        'confirmUrl',
        'cancelUrl',
        'var1',
        'var2',
        'var3',
        'var4',
        'var5',
        'var6',
        'var7',
        'var8',
        'var9',
        'digest' // <- usually appended last in payload
    ],

    paymentAdvice: [
        'version',
        'mid',
        'orderid',
        'status',
        'orderAmount',
        'currency',
        'paymentTotal',
        'message',
        'riskScore',
        'payMethod',
        'txId',
        'paymentRef',
        'extToken',
        'extTokenPanEnd',
        'extTokenExp'
        // 'digest' is calculated, not included in hash
    ],

    captureAdvice: [
        'version',
        'mid',
        'orderid',
        'txId',
        'captureAmount',
        'digest'
    ],

    cancelAdvice: ['version', 'mid', 'orderid', 'txId', 'digest'],

    refundAdvice: [
        'version',
        'mid',
        'orderid',
        'txId',
        'refundAmount',
        'digest'
    ],

    recurringAdvice: [
        'version',
        'mid',
        'orderid',
        'extToken',
        'extTokenExp',
        'orderAmount',
        'currency',
        'digest'
    ]
};
